//@flow

type ActionType = "Kiosk/RESTART_SESSION" | "Kiosk/EXTEND_SESSION"

type KioskAction = {
  type: ActionType
}

type KioskState = {
  +sessionStarted: number,
  +lastInteraction: number
}

export const restartSession = (): KioskAction => {
  return {
    type: "Kiosk/RESTART_SESSION"
  }
}

export const extendSession = (): KioskAction => {
  return {
    type: "Kiosk/EXTEND_SESSION"
  }
}

const makeTime = (): number => new Date().getTime() / 1000

export const sessionStartTime = (state: { kiosk: KioskState }): number =>
  state.kiosk.sessionStarted

export const sessionLastTouched = (state: { kiosk: KioskState }): number =>
  state.kiosk.lastInteraction

export const sessionLengthMature = (state: { kiosk: KioskState }): boolean =>
  state.kiosk.lastInteraction - state.kiosk.sessionStarted > 60

export const reducer = (state: KioskState, action: KioskAction): KioskState => {
  switch (action.type) {
    case "Kiosk/RESTART_SESSION":
      return {
        ...state,
        sessionStarted: makeTime(),
        lastInteraction: makeTime()
      }
    case "Kiosk/EXTEND_SESSION":
      return {
        ...state,
        lastInteraction: makeTime()
      }
    default:
      return (
        state || {
          sessionStarted: makeTime(),
          lastInteraction: makeTime()
        }
      )
  }
}



// WEBPACK FOOTER //
// ./src/Kiosk/redux.js